import { createFileRoute, notFound } from "@tanstack/react-router";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { getProductByIdPrefix } from "@/lib/products.functions";
import { idFromSlug } from "@/lib/format";
import { ReviewInviteModal } from "@/components/storefront/ReviewInviteModal";

type ReviewSearch = { e?: string; n?: string };

const productQO = (idPrefix: string) =>
  queryOptions({
    queryKey: ["product", idPrefix],
    queryFn: () => getProductByIdPrefix({ data: { idPrefix } }),
  });

export const Route = createFileRoute("/p/$slug/review")({
  validateSearch: (search: Record<string, unknown>): ReviewSearch => ({
    e: typeof search.e === "string" ? search.e : typeof search.email === "string" ? search.email : undefined,
    n: typeof search.n === "string" ? search.n : typeof search.name === "string" ? search.name : undefined,
  }),
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: ReviewInvitePage,
});

function ReviewInvitePage() {
  const { slug } = Route.useParams();
  const { e, n } = Route.useSearch();
  const { data } = useSuspenseQuery(productQO(idFromSlug(slug)));
  if (!data.product) throw notFound();
  const p = data.product;
  return (
    <ReviewInviteModal
      productId={p.id}
      productPsId={p.ps_id ?? undefined}
      productName={p.name}
      productImage={p.image_url}
      name={(n ?? "").trim()}
      email={(e ?? "").trim()}
      slug={slug}
    />
  );
}
